import { useState } from 'react';

import { Select } from '@/components/DesignLibrary/Atoms';
import Modal from '@/components/Modal';
import Button from '@/components/DesignLibrary/Button';
import type { Questionnaire } from '@/typings/Questionnaire';

import getDisplayValue from '../getDisplayValue';

import s from './MarkAsDuplicateModal.module.scss';

const MarkAsDuplicateModal: React.FC<{
  onClose: () => void;
  onConfirm: (originalFieldId: string | null) => void;
  fields: Array<Record<string, unknown>
  & {
    id: string;
    _id: string;
    _associatedWithId?: string;
  }>;
  checkedRows: string[];
  fullField: Questionnaire.Field;
  initialOriginalFieldId: string | null;
  selectedOriginalFieldId: string | null;
  setSelectedOriginalFieldId: (e: string | null) => void;
}> = ({ onClose, onConfirm, fields, checkedRows, fullField, initialOriginalFieldId, selectedOriginalFieldId, setSelectedOriginalFieldId }) => {
  const [ignoreInitial, setIgnoreInitial] = useState(false);
  const availableOriginalFields = fields.filter(field => !checkedRows.includes(field.id) && !field._associatedWithId);

  return (
    <Modal
      onClose={onClose}
      title={`Mark ${checkedRows.length} item${checkedRows.length === 1 ? '' : 's'} as duplicate${checkedRows.length === 1 ? '' : 's'} of...`}
      drag
    >
      <div className={s.container}>
        <Select
          label="Original Field"
          compact
          optional
          canClearSelection={false}
          options={[
            { key: 'no', label: 'None' },
            ...availableOriginalFields.map(field => {
              const titleField = fullField.listItemTemplates?.find(f => f.isTitleField);
              const fieldKey = titleField?.key;
              return {
                description: field._id,
                key: field._id,
                label: titleField && fieldKey ? getDisplayValue({ options: titleField.options, type: titleField.type }, field[fieldKey]) : '—',
              };
            }),
          ]}
          onChange={value => {
            setSelectedOriginalFieldId(value === 'no' ? null : value);
            setIgnoreInitial(true);
          }}
          value={(ignoreInitial ? selectedOriginalFieldId : initialOriginalFieldId) || 'no'}
        />
        <div className={s.actions}>
          <Button fullWidth variant="secondary" size="md" onClick={onClose}>
            Cancel
          </Button>
          <Button
            fullWidth
            variant="primary"
            size="md"
            onClick={() => {
              onConfirm(selectedOriginalFieldId);
              onClose();
            }}
          >
            Confirm
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MarkAsDuplicateModal;
